import * as React from "react";
import { connect } from 'react-redux';
import { Fragment } from "react";

import {
  processingLoaderVisibilitySelector,
  generatingLoaderVisibilitySelector,
  starterLoaderVisibilitySelector,
  goAppModalVisibilitySelector,
  generatingLoaderProgressSelector
} from "../../../store/selectors";
import LayoutComponentsModalGoApp from "../../components/modal-goapp";
import { setGoAppModalVisibility } from "../../../store/actions";
import LayoutComponentsLoaderGenerating from "../../components/loader-generating";
import LayoutComponentsLoaderProcessing from "../../components/loader-processing";
import {createLlamaShowAnimationSelector} from "../../../../stickers/store/create-llama/selectors";

class LayoutComponentsOverflowLoader extends React.PureComponent {
  render() {
    return (
      <Fragment>
        <LayoutComponentsModalGoApp
          show={this.props.showGoAppModal}
          onHide={this.props.hideGoAppModal} />
        <LayoutComponentsLoaderGenerating show={this.props.showGeneratingModal}
                                          progress={this.props.generatingModalProgress}
                                          showTheme={this.props.showAnimation}/>
        <LayoutComponentsLoaderProcessing show={this.props.showProcessingModal}/>
        <LayoutComponentsLoaderProcessing show={this.props.showStarterModal} opacity={1}/>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    showProcessingModal: processingLoaderVisibilitySelector(state),
    showGeneratingModal: generatingLoaderVisibilitySelector(state),
    showStarterModal: starterLoaderVisibilitySelector(state),
    showGoAppModal: goAppModalVisibilitySelector(state),
    generatingModalProgress: generatingLoaderProgressSelector(state),
    showAnimation: createLlamaShowAnimationSelector(state),
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    hideGoAppModal: () => dispatch(setGoAppModalVisibility(false))
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(LayoutComponentsOverflowLoader);